export const PARTIES_ROUTES = {
  PARTIES: "/parties",
  PARTY_IDENTITY_REVIEW: "/parties/identity-review",
  SUPPLIER_DIRECTORY: "/parties/suppliers",
  SUPPLIER_IDENTITY_REVIEW: "/parties/suppliers/identity-review",
  PARTNER_DIRECTORY: "/parties/partners",
  PARTNER_IDENTITY_REVIEW: "/parties/partners/identity-review",
} as const;

export type PartiesRouteKey = keyof typeof PARTIES_ROUTES;
